var Game = React.createClass({
  mixins: [React.addons.PureRenderMixin],

  getInitialState: function() {
    var o = storage.get()
    body.attr('data-theme', o.theme ? o.theme : 'white')
    ios.on(
      'disconnect',
      function(reason, a, b) {
        this.setState({
          rooms: [],
        })
      }.bind(this),
    )
    ios.on(
      'a',
      function(data) {
        switch (data.id) {
          case 'rooms': {
            window.rooms = u.toArray(data.rooms)
            this.setState({
              rooms: window.rooms,
            })
            break
          }
          case 'room switch to': {
            if (window.room && window.room.id) {
            }
            break
          }
          case 'embed': {
            if (window.embed && window.embed[data.f]) {
              /*if (document.hidden) window.embed[data.f](data.d)
              else {
              	requestAnimationFrame(function() {*/
              window.embed[data.f](data.d)
            /*})
            }*/
            }
            break
          }
          case 'embedUser': {
            if (data.p == window.user.username && window.embed && window.embed[data.f]) {
              /*if (document.hidden) window.embed[data.f](data)
              else {
              	requestAnimationFrame(function() {*/
              window.embed[data.f](data)
            /*})
            }*/
            }
            break
          }
        }
      }.bind(this),
    )
    return {
      rooms: [],
      qp: {
        swapples: [],
        pool: [],
        watchtogether: [],
        watchanything: [],
        bubblesni: [],
        '9ball': [],
        balloono: [],
        balloonobeta: [],
        balloonoboot: [],
        balloonoarena: [],
        skypigs: [],
        blocklesmulti: [],
        tonk3: [],
        bubbles: [],
        blockles: [],
        dinglepop: [],
        gemmers: [],
        checkers: [],
        cuacka: [],
        poker: [],
        // penguin: [],
        fourplay: [],
      },
    }
  },
  render: function() {
    var games = [
      ['swapples', 'swapples', 'swapples.jpg', 'Fast Swapples'],
      ['pool', 'pool', 'pool.jpg', 'Pool'],
      ['9ball', '9ball', '9ball.jpg', '9 Ball'],
      ['watchtogether', 'watchtogether', 'watchtogether.jpg', 'YouTube'],
      ['dinglepop', 'dinglepop', 'dinglepop.jpg', 'Dinglepoop'],
      ['bubblesni', 'bubbles', 'dinglepop.jpg', 'Dingle NI'],
      ['balloonoarena', 'balloonoarena', 'balloonoarena.jpg', 'Balloono Arena'],
      ['balloono', 'balloono', 'balloono.jpg', 'Balloono'],
      // ['balloonobeta', 'balloonobeta', 'balloono.jpg', 'Balloono Beta'],
      ['balloonoboot', 'balloonoboot', 'balloonoboot2.jpg', 'Balloono Boot'],
      ['skypigs', 'skypigs', 'skypigs.jpg', 'Sky Squad'],
      ['blockles', 'blockles', 'blockles.jpg', 'Chill Blockles'],
      ['blocklesmulti', 'blockles', 'blockles.jpg', 'Intense Blockles'],
      ['tonk3', 'tonk3', 'tonk3.jpg', 'Tonk'],
      // ['bubbles', 'bubbles', 'dinglepop.jpg', 'Dinglepoop'],
      ['gemmers', 'gemmers', 'gemmers.jpg', 'Gemmers'],
      ['checkers', 'checkers', 'checkers.jpg', 'Checkers'],
      ['cuacka', 'cuacka', 'cuacka.jpg', 'PacMan'],
      // ['poker', 'poker', 'poker.jpg', 'Poker'],
      ['watchanything', 'watchanything', 'watchanything.jpg', 'AnyTube'],

    // ['penguin', 'penguin', 'penguin.jpg', 'Penguin'],
    // ['fourplay', 'fourplay', 'fourplay.jpg', 'Fourplay'],
    ]

    if (this.props.room && this.props.room.game) {
      u._title_original = u.capital(this.props.room.game)
      u.title()
    } else {
      u._title_original = 'Lobby'
      u.title()
    }
    return (
      <div className="game-container">
				{this.props.room && this.props.room.game ? (
        <div className="game">
						<Box className="toolbar break clear flex flex-row " wrap vertical-waterfall>
							<Box grow wrap text-crop>
								<Box text-crop>
									<span
        title="Click To Toggle Public/Private Status"
        className="pointer"
        onClick={this.room_toggle_private}
        >
										{this.props.room.private ? 'Private' : 'Public'}
									</span>{' '}
									/{' '}
									<span
        title="Click To Copy Room Link"
        className="pointer"
        onClick={this.copy_room_link}
        style={{
          fontWeight: 'bold'
        }}
        >
										{this.props.room.creator}
									</span>{' '}
									/ #{this.props.room.round.id} /{' '}
									<Editable
        className="name"
        html={this.props.room.name.replace(/#name#/g, window.room.users[0].username)}
        title="Click To Edit Match Name"
        onChange={this.room_set_name}
        />
								</Box>
							</Box>
							<Box element="small" wrap vertical-waterfall uppercase>
								{ /*<a
									className="pointer underline-hover white underline corange"
									href="#p/Tournaments"
								>
									<b>Tournaments</b>
								</a>{' '}
								|{' '}*/ }
								<a className="pointer underline-hover white no-underline" href="#u/mobcpop.com">
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="shop"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
        />
									</svg>
								</a>{' '}
								|	{' '}
								<a className="pointer underline-hover white no-underline guest-hidden" href="#p/Emoji">
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="shop"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M260.6 319.8l-47.1 .0199L205.5 305.6c-4-10.75-14.25-17.77-25.63-17.77H108.1c-11.38 0-21.62 7.018-25.62 17.77l-7 14.25l-48-.0199C12.25 319.8 0 332.1 0 347.2v137.3c0 15.25 12.25 27.47 27.38 27.47h233.2c15.12 0 27.37-12.22 27.37-27.47L288 347.2C288 332.1 275.7 319.8 260.6 319.8zM144 467.1c-28.75 0-52-23.25-52-52s23.25-52 52-52s52 23.25 52 52S172.8 467.1 144 467.1zM116.6 219.3c3 3.125 7.101 4.744 11.35 4.744S136.4 222.5 139.2 219.3L235.1 119.5c28.25-29 26.5-77.12-4.875-103.9c-27.38-23.38-68.12-19.13-93.25 6.874L127.1 32.58L118.1 22.45c-25.12-26-65.87-30.25-93.25-6.874c-31.38 26.75-33 74.87-5 103.9L116.6 219.3zM478 .3438l-148.6 22.75c-14.62 2.25-25.5 15.75-25.5 31.75v106.7c-5.25-1.125-10.62-1.585-15.99-1.71c-35.38 0-63.1 21.52-63.1 48.03s28.62 48.03 63.1 48.03c35.25 0 63.76-21.4 64.01-47.78L352 99.59l112-17.13l-.0417 47.12c-5.25-1.125-10.62-1.585-15.99-1.71c-35.38 0-63.1 21.49-63.1 47.99c0 26.63 28.62 47.1 63.1 47.1c35.25 0 63.75-21.43 63.1-47.81l.0034-144.1C511.1 12.47 495.9-2.406 478 .3438zM496 368h-55.72l38.44-89.7c2.938-6.859 .7187-14.84-5.312-19.23c-6.094-4.422-14.34-4.031-19.94 .8906l-128 112c-5.031 4.391-6.781 11.44-4.438 17.67C323.4 395.9 329.3 400 336 400h55.72l-38.44 89.7c-2.938 6.859-.7187 14.84 5.312 19.23C361.4 510.1 364.7 512 368 512c3.781 0 7.531-1.328 10.53-3.953l128-112c5.031-4.391 6.781-11.44 4.438-17.67C508.6 372.1 502.7 368 496 368z"
        />
									</svg>
								|</a>
								
								<a
        className="pointer button-ranking no-select white no-underline guest-hidden"
        title="Game Rankings"
        href="#p/Ranking"
        >
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="medal"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M223.7 130.8L149.1 7.77C147.1 2.949 141.9 0 136.3 0H16.03c-12.95 0-20.53 14.58-13.1 25.18l111.3 158.9C143.9 156.4 181.7 137.3 223.7 130.8zM256 160c-97.25 0-176 78.75-176 176S158.8 512 256 512s176-78.75 176-176S353.3 160 256 160zM348.5 317.3l-37.88 37l8.875 52.25c1.625 9.25-8.25 16.5-16.63 12l-46.88-24.62L209.1 418.5c-8.375 4.5-18.25-2.75-16.63-12l8.875-52.25l-37.88-37C156.6 310.6 160.5 299 169.9 297.6l52.38-7.625L245.7 242.5c2-4.25 6.125-6.375 10.25-6.375S264.2 238.3 266.2 242.5l23.5 47.5l52.38 7.625C351.6 299 355.4 310.6 348.5 317.3zM495.1 0H375.7c-5.621 0-10.83 2.949-13.72 7.77l-73.76 122.1c42 6.5 79.88 25.62 109.5 53.38l111.3-158.9C516.5 14.58 508.9 0 495.1 0z"
        />
									</svg>
								|</a>{' '}
								
								<a className="pointer underline-hover white no-underline guest-hidden" href="#p/Shop">
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="shop"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M483.5 256C471.3 256 459.4 254 448 250.5V384H127.9V250.5C116.5 254 104.5 256 92.35 256C86.9 256 81.45 255.6 75.1 254.9C71.82 254.4 68.02 252.8 64 251.7L64.01 464c0 26.51 21.49 48 47.1 48h352.1c26.51 0 47.1-21.49 47.1-48l.0355-212.3c-4.146 1.082-8.088 2.709-12.4 3.281C494.4 255.6 489 256 483.5 256zM547.6 103.8l-57.32-90.68c-5.105-8.15-14.21-13.13-23.93-13.13H109.6c-9.717 0-18.82 4.979-23.93 13.13L28.33 103.8c-29.59 46.83-3.41 111.9 51.9 119.4C84.21 223.7 88.3 224 92.36 224c26.14 0 49.29-11.38 65.19-28.97C173.4 212.6 196.7 224 222.7 224c26.14 0 49.29-11.38 65.19-28.97C303.8 212.6 327 224 353.1 224c26.17 0 49.29-11.38 65.19-28.97C434.2 212.6 457.4 224 483.4 224c4.141 0 8.113-.2734 12.09-.793C551 215.8 577.3 150.7 547.6 103.8z"
        />
									</svg>
								|</a>
								{' '}
								<a className="button-change-game no-italic pointer relative hidden creator host mod pu">
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="gamepad"
        style={{
          paddingTop: "5px"
        }}
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M480 96H160C71.6 96 0 167.6 0 256s71.6 160 160 160c44.8 0 85.2-18.4 114.2-48h91.5c29 29.6 69.5 48 114.2 48 88.4 0 160-71.6 160-160S568.4 96 480 96zM256 276c0 6.6-5.4 12-12 12h-52v52c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-52H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h52v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h52c6.6 0 12 5.4 12 12v40zm184 68c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-80c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        />
									</svg>
									<div className="font selector">
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="pool"
        title="Play Pool"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/pool.png"
        width="21"
        height="21"
        />{' '}
											Pool
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="swapples"
        title="Play Swapples"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/swapples.png"
        width="21"
        height="21"
        />{' '}
											Swapples
										</div>

										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="blockles"
        title="Play Blockles"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/blockles.png"
        width="21"
        height="21"
        />{' '}
											Blockles
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="blocklesmulti"
        title="Play Blockles Multiplayer"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/blocklesm.png"
        width="21"
        height="21"
        />{' '}
											Blockles M
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="bubbles"
        title="Play Bubbles"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/dinglepop.png"
        width="21"
        height="21"
        />{' '}
											Dingle M
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="bubblesni"
        title="Play Bubbles No items"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/dinglepopni.png"
        width="21"
        height="21"
        />{' '}
											Dingle NI
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="dinglepop"
        title="Play Bubbla"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/dinglepop.png"
        width="21"
        height="21"
        />{' '}
											Dingle
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="tonk3"
        title="Play Tonk"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/tonk3.png"
        width="21"
        height="21"
        />{' '}
											Tonk
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="9ball"
        title="Play 9ball"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/9ball.png"
        width="21"
        height="21"
        />{' '}
											9 Ball
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="skypigs"
        title="Play Skypigs"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/skypigs.png"
        width="21"
        height="21"
        />{' '}
											Sky Squad
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="gemmers"
        title="Play Gemmers"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/gemmers.png"
        width="21"
        height="21"
        />{' '}
											Gemmers
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="balloonoarena"
        title="Play Balloono"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/balloonoarena.png"
        width="21"
        height="21"
        />{' '}
											Balloonorena
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="balloono"
        title="Play Balloono"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/balloono.png"
        width="21"
        height="21"
        />{' '}
											Balloono
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="balloonoboot"
        title="Play Balloono Boot"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/balloonoboot.png"
        width="21"
        height="21"
        />{' '}
											Balloono Boot
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="checkers"
        title="Play Checkers"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/checkers.png"
        width="21"
        height="21"
        />{' '}
											Checkers
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="cuacka"
        title="Play PacMan"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/cuacka.png"
        width="21"
        height="21"
        />{' '}
											PacMan
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="watchtogether"
        title="YouTube Together"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/watchtogether.png"
        width="21"
        height="21"
        />{' '}
											YouTube
										</div>
										<div
        className="to-game"
        onClick={this.room_switch_to}
        data-game="watchanything"
        title="Anytube"
        >
											<img
        alt="🖼"
        src="https://mobcpop.com/img/icon/watchanything.png"
        width="21"
        height="21"
        />{' '}
											Anytube
										</div>
									</div>
								</a>
								<a className="button-change-game no-italic pointer relative hidden creator host mod pu"
        style={{
          minHeight: "0px",
          padding: "0px"
        }}>
								|{' '}
								</a>
								<span
        className={
        'pointer button-rotate button-rotate-opponent no-select hidden host creator mod ' +
        (window.room.started &&
        (window.room.users[0].username == window.user.username ||
        (window.room.users[1] &&
        window.room.users[1].username == window.user.username))
          ? ' hidden '
          : '')
        }
        onClick={this.room_rotate_opponent}
        >
									<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path
        fill="currentColor"
        d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
        />
									</svg>{' '}
									Opp. |{' '}
								</span>{' '}
								<span
        className={
        'pointer button-rotate no-select ' +
        (window.room.started &&
        window.room.game != 'watchtogether' &&
        (window.room.users[0].username == window.user.username ||
        (window.room.users[1] &&
        window.room.users[1].username == window.user.username))
          ? ' hidden '
          : '')
        }
        onClick={this.room_rotate}
        >
									<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path
        fill="currentColor"
        d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
        />
									</svg>{' '}
									|{' '}
								</span>{' '}
								
								<span
        className="pointer button-clear-kicks hidden creator mod pu no-select guest-hidden"
        title="Clear Kicks"
        onClick={this.room_clear_kicks}
        >
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="balance-scale"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path
        fill="currentColor"
        d="M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        />
									</svg>{' '}
									|{' '}
								</span>{' '}
								<span
        title="Click To Toggle Kicks"
        className="pointer button-allow-kicks guest-hidden"
        onClick={this.room_allow_kicks}
        >
								<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="kicks"
        role="img"
        fill={
        this.props.room.kicks || this.props.room.kicks == undefined ? 'white' : 'red'
        }
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        >
										<path d="M509.982,380.674c-6.038-18.941-23.777-30.446-37.593-36.763c-28.384-12.976-59.512-40.574-87.356-72.09l4.154-2.551    c3.575-2.195,4.694-6.874,2.499-10.449c-2.196-3.577-6.873-4.692-10.45-2.499l-6.225,3.822c-3.638-4.361-7.201-8.769-10.678-13.2    l6.181-4.017c3.518-2.286,4.516-6.992,2.229-10.51c-2.286-3.519-6.994-4.517-10.51-2.23l-7.15,4.648    c-4.004-5.39-7.858-10.775-11.537-16.111l5.307-3.296c3.565-2.214,4.659-6.898,2.444-10.462c-2.216-3.566-6.899-4.66-10.463-2.444    l-5.737,3.565c-10.014-15.469-18.31-30.17-24.198-42.89c-0.851-2.282-8.099-23.21,6.35-37.658    c2.967-2.967,2.967-7.778-0.001-10.744c-2.966-2.967-7.777-2.967-10.744,0c-15.575,15.576-14.263,35.425-11.94,46.271    c-9.082,2.578-26.163,6.855-45.351,8.775c-45.518,4.558-67.888-7.296-78.633-18.042c-39.043-39.042-41.575-77.949-41.595-78.311    c-0.149-3.186-2.272-5.938-5.314-6.893c-3.044-0.955-6.357,0.091-8.3,2.621L1.572,217.365c-1.292,1.684-1.822,3.83-1.461,5.921    c0.361,2.091,1.58,3.935,3.362,5.087c2.126,1.375,213.344,137.893,272.866,174.032c48.443,29.412,114.283,43.351,164.693,43.35    c15.222,0,29.044-1.272,40.546-3.773c1.89-0.41,3.552-1.526,4.648-3.12l23.617-34.354c0.016-0.023,0.027-0.051,0.044-0.075    c0.183-0.273,0.349-0.558,0.496-0.853c0.028-0.054,0.051-0.109,0.077-0.165c0.13-0.278,0.243-0.563,0.339-0.857    c0.01-0.029,0.025-0.057,0.034-0.086c0.006-0.021,0.019-0.066,0.028-0.094c0.009-0.032,0.019-0.064,0.028-0.096    C511.359,400.686,513.584,391.969,509.982,380.674z M181.707,293.419c58.135,37.165,97.92,62.275,118.252,74.632    c48.443,29.413,114.283,43.35,164.692,43.35c8.021,0,15.638-0.363,22.747-1.063l-11.957,17.392    c-23.67,4.537-56.217,3.738-89.962-2.261c-38.183-6.788-74.143-19.592-101.254-36.052    C231.002,357.104,55.745,244.043,18.642,220.085l16.18-21.064c54.161,34.954,96.012,61.822,121.842,78.373    c1.269,0.813,2.687,1.201,4.091,1.201c2.503,0,4.953-1.236,6.403-3.5c2.264-3.533,1.236-8.231-2.298-10.495    c-11.441-7.331-26.032-16.691-43.438-27.877c7.952-14.643,12.129-31.048,12.129-47.885c0-23.357-8.193-46.109-23.068-64.065    c-2.678-3.232-7.468-3.68-10.698-1.004c-3.23,2.677-3.68,7.467-1.003,10.697c12.623,15.236,19.575,34.546,19.575,54.371    c0,13.913-3.365,27.469-9.763,39.638c-18.828-12.109-40.434-26.023-64.486-41.545l72.964-94.991    c4.646,16.911,15.844,43.684,42.761,70.601c38.645,38.645,116.899,19.603,140.053,12.831c5.899,11.911,13.541,25.097,22.354,38.7    l-25.812,16.034c-3.565,2.214-4.659,6.898-2.444,10.462c1.439,2.317,3.921,3.589,6.461,3.589c1.37,0,2.754-0.37,4.002-1.145    l26.238-16.299c3.753,5.455,7.662,10.933,11.692,16.382l-20.513,13.333c-3.518,2.287-4.516,6.993-2.229,10.511    c1.456,2.24,3.891,3.458,6.377,3.458c1.419,0,2.855-0.397,4.133-1.229l21.443-13.938c3.402,4.366,6.867,8.683,10.373,12.929    l-19.075,11.713c-3.575,2.195-4.694,6.874-2.499,10.449c1.434,2.336,3.928,3.623,6.481,3.623c1.356,0,2.728-0.363,3.969-1.124    l21.08-12.944c41.558,47.63,73.969,68.628,94.155,77.855c27.515,12.579,30.867,28.587,30.756,36.049    c-23.464,4.075-55.031,3.148-87.729-2.665c-38.183-6.788-74.143-19.592-101.251-36.05    c-20.233-12.295-59.919-37.343-117.957-74.446c-3.536-2.26-8.232-1.227-10.493,2.309    C177.139,286.462,178.172,291.159,181.707,293.419z" />
									</svg>
									{ /*{this.props.room.kicks ? 'Allowed' : 'Not Allowed'}*/ }|{' '}
								</span>{' '}
								<span
        title="Start the Game"
        className="pointer button-start hidden host mod no-select"
        onClick={this.start}
        >
									{' '}
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="play"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        >
										<path
        fill="currentColor"
        d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
        />
									</svg>{' '}
									Start |{' '}
								</span>
								<span
        title="Stop the Game"
        className="pointer button-stop hidden host mod no-select"
        onClick={this.stop}
        >
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="stop"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        >
										<path
        fill="currentColor"
        d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        />
									</svg>{' '}
									|{' '}
								</span>{' '}
								<a
        className="pointer button-leave no-select white no-underline"
        href="#"
        title="Leave Game"
        >
									<svg
        aria-hidden="true"
        data-prefix="fas"
        data-icon="reply"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        >
										<path
        fill="currentColor"
        d="M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
        />
									</svg>{' '}
									<span className="leaveText">Leave</span>
								</a>
							</Box>
						</Box>
						{this.props.room.game == 'pool' ? <GamePool room={this.props.room} /> : null}
						{this.props.room.game == '9ball' ? <Game9Ball room={this.props.room} /> : null}
						{this.props.room.game == 'swapples' ? (
          <GameSwapples room={this.props.room} data={this.props.data} />
          ) : null}

						{this.props.room.game == 'watchtogether' ? (
          <GameWatchtogether room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'watchanything' ? (
          <GameWatchanything room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'skypigs' ? (
          <GameSkypigs room={this.props.room} data={this.props.data} />
          ) : null}

						{this.props.room.game == 'bubbles' ? (
          <GameBubbles room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'bubblesni' ? (
          <GameBubblesNi room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'dinglepop' ? (
          <GameDinglepop room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'blockles' ? (
          <GameBlockles room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'blocklesmulti' ? (
          <GameBlocklesMulti room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'gemmers' ? (
          <GameGemmers room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'tonk3' ? (
          <GameTonk3 room={this.props.room} data={this.props.data} />
          ) : null}

						{this.props.room.game == 'balloono' ? (
          <GameBalloono room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'balloonoboot' ? (
          <GameBalloonoboot room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'balloonobeta' ? (
          <GameBalloonoBeta room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'balloonoarena' ? (
          <GameBalloonoArena room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'checkers' ? (
          <GameCheckers room={this.props.room} data={this.props.data} />
          ) : null}
						{this.props.room.game == 'cuacka' ? (
          <GameCuacka room={this.props.room} data={this.props.data} />
          ) : null}

						{this.props.room.game == 'poker' ? (
          <GamePoker room={this.props.room} data={this.props.data} />
          ) : null}
						{ /*{this.props.room.game == 'fourplay' ? (
							<GameFourplay room={this.props.room} data={this.props.data} />
						) : null}
					*/ }
					</div>
        ) : (
        <div className="home">
						<div className="toolbar guest-tool-hidden">
							{ /*<span className="slogan">Play, make new friends and have fun!</span>*/ }
							<small className="r guest-hidden">
								{ /*<a
									className="pointer underline-hover white underline corange"
									href="#p/Tournaments"
								>
									<b>Tournaments</b>
								</a>{' '}
								| */ }
								<a className="pointer underline-hover white no-underline" href="#p/Ranking">
									Rankings
								</a>{' '}
								|{' '}
								<a className="pointer underline-hover white no-underline" href="#u/mobcpop.com">
									Admin
								</a>{' '}
								|{' '}
								<a className="pointer underline-hover white no-underline" href="#p/Issues">
									Issues
								</a>{' '}
								|{' '}
								<a className="pointer underline-hover white no-underline" href="#p/FAQs">
									FAQs
								</a>{' '}
								|{' '}
								<a className="pointer underline-hover white no-underline" href="#p/Rules">
									Rules
								</a>{' '}
								|{' '}
								
								<a className="pointer underline-hover white no-underline" href="#p/ChangeLog">
									Change Log
								</a>{' '}
								|{' '}
							
								<a className="pointer underline-hover white no-underline" href="#p/Emoji">
									emoji
								</a>{' '}
								|{' '}
								<a className="pointer underline-hover white no-underline bold" href="#p/Shop">
									Pop Shop
								</a>
							</small>
						</div>

						<div className="home-content games-hidden" >
							<div className="flex-column">
								<div className="game-buttons">
									<span className=" game-button swapples-nof" onClick={this.create_swapples_cls}>
										<img
        alt="🖼"
        width="185"
        height="70"
        src="https://mobcpop.com/img/panel/swapples.jpg"
        />
										<span className="game-title">Swapples</span>
										<div className="game-button-quick" onClick={this.tryJoin}>
											PLAY
										</div>
									</span>

									{games.map((game, i) => {
          return (
            <span
            data-game={game[0]}
            className={'button-' + game[1] + ' game-button'}
            onClick={this.create}
            key={'game' + i}
            >
												<img alt="🖼" width="185" height="70" src={'/img/panel/' + game[2]} />
												{ /*<div className="game-button-create">CREATE</div>*/ }

												<div className="game-button-quick" onClick={this.tryJoin}>
													PLAY
												</div>
												<span className="game-title">{game[3]}</span>
											</span>
          )
        })}
								</div>
							</div>

							<div className="rooms-container">
								<Rooms items={this.state.rooms} />
							</div>
						</div>
					</div>
        )}
			</div>
    )
  },
  create: function(e) {
    var game = e.currentTarget.getAttribute('data-game')

    emit({
      id: 'room create',
      game: game,
    })
  },
  create_swapples_cls: function(e) {
    location.hash = 'm/swapples-nof' + gd()
  },

  tryJoin: function(e) {
    var preferredSize = {
      swapples: 6,
      pool: 2,
      watchtogether: 6,
      watchanything: 6,
      bubblesni: 6,
      '9ball': 2,
      balloono: 6,
      balloonobeta: 6,
      balloonoboot: 6,
      balloonoarena: 6,
      skypigs: 6,
      blocklesmulti: 6,
      tonk3: 3,
      cuacka: 6,
      bubbles: 6,
      blockles: 6,
      dinglepop: 6,
      gemmers: 6,
      checkers: 2,
      penguin: 5,
      fourplay: 2,
      poker: 7,
    }

    var game = e.target.parentElement.getAttribute('data-game')
    var filtered = this.state.rooms.filter(e => e[2] === game)
    var found = false

    for (var room in filtered) {
      if (
        filtered[room][3].length < preferredSize[game] &&
        !this.state.qp[game].includes(filtered[room][0])
      ) {
        found = filtered[room][0]
        break
      }
    }

    var qp = this.state.qp

    if (found !== false) {
      qp[game].push(found)
      location.hash = 'm/' + found
      // e.cancelBubble = true
      if (e.stopPropagation) e.stopPropagation()
    } else {
      qp[game] = []
    }

    if (qp !== this.state.qp) this.setState({
        qp: qp
      })
  },

  room_set_name: function(name) {
    if (this.props.room.name.replace(/#name#/g, window.room.users[0].username) != name)
      emit({
        id: 'room update',
        name: name.replace(window.room.users[0].username, '#name#'),
      })
  },
  copy_room_link: function() {
    navigator.clipboard.writeText('https://mobcpop.com/index.html#m/' + this.props.room.id)
  },
  room_toggle_private: function() {
    emit({
      id: 'room update',
      private: !this.props.room.private,
    })
  },
  room_switch_to: function(e) {
    emit({
      id: 'room switch to',
      game: $(e.currentTarget).attr('data-game'),
    })
  },
  room_toggle_guest: function() {
    emit({
      id: 'room update',
      guest: !this.props.room.guest,
    })
  },
  room_rotate: function() {
    emit({
      id: 'room rotate',
    })
  },
  room_rotate_opponent: function() {
    CONFIRM('Are you Sure you want to Rotate The Opponent?', function() {
      emit({
        id: 'room rotate opponent',
      })
    })
  },
  room_clear_kicks: function() {
    CONFIRM('Are you Sure you want to Clear Kicks?', function() {
      emit({
        id: 'room clear kicks',
      })
    })
  },
  room_allow_kicks: function() {
    if (this.props.room.kicks == undefined) {
      this.props.room.kicks = true
    }
    emit({
      id: 'room update',
      kicks: !this.props.room.kicks,
    })
  },
  start: function() {
    if (window.swf && window.swf.start) {
      window.swf.start()
    }
  },
  stop: function() {
    if (window.swf && window.swf.stop) {
      window.swf.stop()
    }
  },
})

$(function() {
  ReactDOM.render(<Game room="" data="" />, document.querySelector('.content-container .content'))
})